import {
  Component, ChangeDetectionStrategy, Input, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit
} from '@angular/core';
import { gsap, Linear } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import { DefaultSlideWidth, SlideGapByWidth, SlidePerByWidth } from '@ux/components/slide/entities/slide.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonIconSize, ButtonIconType } from '@design-system/components/molecules/button-icon/entities/button-icon.types';

@Component({
  selector: 'app-slide',
  templateUrl: 'slide.component.html',
  styleUrls: ['./slide.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SlideComponent implements AfterViewInit {

  @Input() mechanicalDisplacement = false;
  @Input() activated = false;
  @Input() quantityOfItems = 0;
  @Input() slideWidth = DefaultSlideWidth;

  @ViewChild('slide') slideRef: ElementRef;

  public readonly icon = Icon;
  public readonly buttonIconSize = ButtonIconSize.XL;
  public readonly buttonType = ButtonIconType.Primary;

  public showl = false;
  public showr = false;

  constructor(
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.detectChanges();
  }

  get slidePer(): number {
    return this.mechanicalDisplacement ? SlidePerByWidth?.[this.slideWidth] ?? SlidePerByWidth[DefaultSlideWidth] : null;
  }

  get gap(): string {
    return this.mechanicalDisplacement ? SlideGapByWidth?.[this.slideWidth] ?? SlideGapByWidth[DefaultSlideWidth] : null;
  }

  public previous(): void {
    this.scrollTo(this.slideRef?.nativeElement?.scrollLeft - this.slideWidth - this.slidePer, 0.6);
  }

  public next(): void {
    this.scrollTo(this.slideRef?.nativeElement?.scrollLeft + this.slideWidth + this.slidePer, 0.6);
  }

  private scrollTo(position: number, duration: number): void {
    gsap.registerPlugin(ScrollToPlugin);
    gsap.to(this.slideRef?.nativeElement, {
      duration,
      scrollTo: { x: position },
      ease: Linear.easeNone,
      onComplete: () => this.detectChanges()
    });
  }

  private showLeft(): void {
    this.showl = this.slideRef?.nativeElement.scrollLeft > 0;
  }

  private showRight(): void {
    this.showr = this.slideRef?.nativeElement.scrollLeft
      + this.slideRef?.nativeElement.clientWidth < this.slideRef?.nativeElement.scrollWidth;
  }

  private detectChanges(): void {
    this.showLeft();
    this.showRight();
    this.cdr.detectChanges();
  }

}
